var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.62 79.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.64,0l-3.5,3.49L155.6,20l-4.42-3.89-3.71-3.25L141,20.34l3.74,3.25,7.91,6.93,3.47,3.06,3.27-3.28,19.79-19.79L182.62,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.92,78.65V50.53L0,4.94H12.56l9.1,29.21L30.21,4.94H42.5L27.76,50.53V78.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.59,78.65V4.94H79.53V14.4H62.06V35.61H75.8V45H62.06V69.37H79.72v9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.11,79.65A21.93,21.93,0,0,1,95,77.06a16.4,16.4,0,0,1-6.73-7.6,32.54,32.54,0,0,1-2.55-12.29L97.28,54.9a35.33,35.33,0,0,0,1,7.55,10.9,10.9,0,0,0,2.63,5,6.37,6.37,0,0,0,4.69,1.78c2.18,0,3.73-.66,4.64-2a8.49,8.49,0,0,0,1.37-5,13.4,13.4,0,0,0-2.19-7.92,34.39,34.39,0,0,0-5.82-6.19l-9.28-8.19a27.86,27.86,0,0,1-6.24-7.5,20.79,20.79,0,0,1-2.32-10.24q0-8.75,5.1-13.47t13.92-4.73a20.72,20.72,0,0,1,8.65,1.59,13.8,13.8,0,0,1,5.5,4.41,20,20,0,0,1,3,6.42,37.58,37.58,0,0,1,1.27,7.6l-11.46,2a39.59,39.59,0,0,0-.77-6.19,8.63,8.63,0,0,0-2.1-4.27,5.88,5.88,0,0,0-4.41-1.55,5.58,5.58,0,0,0-4.6,2A7.44,7.44,0,0,0,98.37,21a11.22,11.22,0,0,0,1.55,6.15,24,24,0,0,0,4.46,5l9.19,8.09a38.32,38.32,0,0,1,7.78,9,22.92,22.92,0,0,1,3.23,12.42,18.63,18.63,0,0,1-2.32,9.37,16.68,16.68,0,0,1-6.46,6.42A19.46,19.46,0,0,1,106.11,79.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/YES.e749931454b5d19f94f0b0e8e66c63d9.svg";
export { ForwardRef as ReactComponent };